import type { VisualizationProps } from './types';

/**
 * WardrobeSVG — гардероб: широкий шкаф-купе с 2 дверцами.
 * Зоны: facade, corpus, handles. Без countertop/hooks. Конвенции — `./types.ts`.
 */
export function WardrobeSVG({ facadeColor, corpusColor, handlesColor }: VisualizationProps) {
  return (
    <svg
      viewBox="0 0 320 200"
      width="100%"
      height="auto"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0" y="0" width="320" height="200" fill="#f9f6f2" />
      <rect x="0" y="185" width="320" height="15" fill="#d8cfc4" />
      <rect
        data-testid="zone-corpus"
        x="20"
        y="15"
        width="280"
        height="170"
        fill={corpusColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        data-testid="zone-facade"
        x="28"
        y="23"
        width="130"
        height="154"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        x="162"
        y="23"
        width="130"
        height="154"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        data-testid="zone-handles"
        x="148"
        y="95"
        width="2"
        height="14"
        fill={handlesColor}
        rx="1"
      />
      <rect x="170" y="95" width="2" height="14" fill={handlesColor} rx="1" />
      <text
        x="90"
        y="105"
        textAnchor="middle"
        fontSize="10"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        1
      </text>
      <text
        x="232"
        y="105"
        textAnchor="middle"
        fontSize="10"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        1
      </text>
      <text
        x="160"
        y="13"
        textAnchor="middle"
        fontSize="9"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        2
      </text>
    </svg>
  );
}
